import login from './login.vue'
export default login



// WEBPACK FOOTER //
// ./src/pages/login/index.js